export default import.meta.ROLLDOWN_FILE_URL_AJY6yyg$Az2Wip$zwfNegg